"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateStreamEvmStatus = void 0;
var api_utils_1 = require("@moralisweb3/api-utils");
var name = 'UpdateStreamStatus';
var method = 'post';
var bodyParams = ['status'];
exports.updateStreamEvmStatus = (0, api_utils_1.createEndpointFactory)(function () {
    return (0, api_utils_1.createEndpoint)({
        name: name,
        getUrl: function (_a) {
            var id = _a.id;
            return "/streams/evm/".concat(id, "/status");
        },
        apiToResult: function (data) { return data; },
        resultToJson: function (data) { return data; },
        parseParams: function (params) { return params; },
        bodyParams: bodyParams,
        method: method,
    });
});
